import Vue from 'vue';
import BaseProxy from './base-proxy';


/**
 * Class RoboticsUserProxy
 */
class RoboticsUserProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  createUser(payload) {
    const toast = {
      success: Vue.i18n.t('user.createUserSuccess'),
      error: 'Tạo người dùng bị lỗi',
    };
    return this.submit('post', `${this.endpoint}/create-new-robotics-user`, payload, { toast });
  }


  inviteUser(payload) {
    const toast = {
      success: Vue.i18n.t('user.invitationHasBeenSent'),
    };
    return this.submit('post', `${this.endpoint}/invite-user-by-email`, payload, { toast });
  }


  updateUserRole(payload) {
    const toast = {
      success: Vue.i18n.t('user.updateRoleSuccess'),
    };
    return this.submit('post', `${this.endpoint}/update-role-robotics-user`, payload, { toast });
  }

  deleteUser(payload) {
    const toast = {
      success: Vue.i18n.t('user.deleteUserSuccess'),
    };
    return this.submit('post', `${this.endpoint}/delete-robotics-user`, payload, { toast });
  }

  getUsers() {
    return this.submit('post', `${this.endpoint}/get-robotics-users`);
  }

  forgotUserPassword(email) {
    const toast = {
      subject: Vue.i18n.t('user.forgotPassword'),
    };
    return this.submit('post', `${this.endpoint}/delete-einvoice-account`, { email }, { toast });
  }
}

export default RoboticsUserProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/robotics-user-proxy.js